"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _coreVerticalStepper = require("@vfuk/core-vertical-stepper");
var _useRecommendationStepper = require("../hooks/recommendation/useRecommendationStepper");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const StepperContainer = _styledComponents.default.div`
  margin-bottom: 20px;
`;
const VerticalStepperComponent = () => {
  const {
    steps,
    currentStep
  } = (0, _useRecommendationStepper.useRecommendationStepper)();
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 5
    }
  }, /*#__PURE__*/_react.default.createElement(StepperContainer, null, /*#__PURE__*/_react.default.createElement(_coreVerticalStepper.VerticalStepper, {
    currentStep: currentStep,
    steps: steps
  })));
};
var _default = VerticalStepperComponent;
exports.default = _default;